
import * as Actions from './receipt.actions';
export const ReceiptActions = Actions;
export { ReceiptState } from './receipt.state';

